module.exports = __webpack_public_path__ + "static/media/openengine-video-2.bf870652.svg";